import { Outlet, useLocation, useParams } from 'react-router-dom';

import { SidebarProvider } from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';
import { Routes } from '@/router/routes';

import { AppSidebar, AuthGate } from '../components';

export const MainTemplate = () => {
  const params = useParams<{ id: string }>();
  const location = useLocation();

  const isEventDetailsPage =
    location.pathname.startsWith(Routes.Events) && !!params.id;

  const mainClassName = cn(
    'flex-1 h-full w-full',
    !isEventDetailsPage && 'p-[24px] pb-[40px]'
  );

  return (
    <AuthGate>
      <SidebarProvider className="max-w-[100vw] overflow-hidden">
        <AppSidebar />
        <main className="flex-1 max-w-full overflow-hidden">
          <div className={mainClassName}>
            <Outlet />
          </div>
        </main>
      </SidebarProvider>
    </AuthGate>
  );
};
